import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import loggerMiddleware from '../middleware/loggerMiddleware';
import rootReducer from './reducers/rootReducer';
import rootSaga from './sagas/saga';

const persistConfig = {
  key: 'root',
  storage,
  // whitelist: ['cart', 'auth', 'delivery'], 
};

const env = process.env.NODE_ENV || 'development';

export default function configureStore(initialState = {}) {
  const sagaMiddleware = createSagaMiddleware();
  const middleware = [sagaMiddleware];

  // if (env === 'development') {
  //   middleware.push(loggerMiddleware);
  // }

  // Wrap rootReducer with persistReducer
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  
  const enhancer = compose(applyMiddleware(...middleware));

  const store = createStore(persistedReducer, initialState, enhancer);
  const persistor = persistStore(store);

  sagaMiddleware.run(rootSaga);

  return { store, persistor };
}
